import React from 'react';

import TrainingHome from '../../Training/TrainingHome';

const TrainingForm = () => <TrainingHome embedded />;

export default TrainingForm;
